import { render, staticRenderFns } from "./AssignmentCreate.vue?vue&type=template&id=fc963112"
import script from "./AssignmentCreate.vue?vue&type=script&lang=js"
export * from "./AssignmentCreate.vue?vue&type=script&lang=js"
import style0 from "./AssignmentCreate.vue?vue&type=style&index=0&id=fc963112&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports